import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Display from "@/pages/Display";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route path="/" element={<Navigate to="/admin" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/display" element={<Display displayKey="main" />} />
          <Route path="/display1" element={<Display displayKey="1" />} />
          <Route path="/display2" element={<Display displayKey="2" />} />
          <Route path="/display3" element={<Display displayKey="3" />} />
          <Route path="/display4" element={<Display displayKey="4" />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
